export const sortCertificates = (tiers, field) => {
  return (tiers || []).sort((a, b) => a[field] - b[field]);
};
